import Vue from 'vue'

// 数字格式化
Vue.filter('formatDecimal', function (value, n = 8) {
  return typeof value == 'number' ? value.toFixed(n) : Number(value).toFixed(n)
})

// 可用余额
Vue.filter('filterDecimalkeyong', (number, digit = 10) => {
  return Number(Math.floor(number * 10000000000) / 10000000000).toFixed(digit)
})

// 价格保留两位小数；不四舍五入
Vue.filter('formatDecimalfloor', function (value, digit = 2) {
  return (Math.floor(parseInt(value * 1000 / 10)) / 100).toFixed(digit)
})
// 币种过滤
Vue.filter('filterCoin', (coin) => {
  const coins = {
    BTC: '比特币',
    LTC: '莱特币',
    ETH: '以太坊',
    WKC: '链克',
    NEWG: '数字黄金',
    CBC: '我家云',
    ORN: '云钻',
    USDT: '泰达币',
    EOS: '柚子',
    AUSD: 'AUSD',
    DAEX: 'DAEX'
  }
  return `${coin} (${coins[coin]})`
})

// 字符串截取
Vue.filter('ellipsis', function (str, sub_length = 10) {
  if (str == "" || str == null) return "";
  var temp1 = str.replace(/[^\x00-\xff]/g, "**");
  var temp2 = temp1.substring(0, sub_length);
  var x_length = temp2.split("\*").length - 1;
  var hanzi_num = x_length / 2;
  sub_length = sub_length - hanzi_num; //实际需要sub的长度是总长度-汉字长度
  var res = str.substring(0, sub_length);
  if (sub_length < str.length) {
    var end = res + "…";
  } else {
    var end = res;
  }
  return end;
})



// WEBPACK FOOTER //
// ./src/filters/index.js